module.exports = "/images/ok.svg?6fc579601adf859e3c010a11fed9f99e";